// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./css/components/_column.scss
// module id = 36
// module chunks = 0